import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, User, UserService } from '@rentigo/ngx-authorization';
import { PspService } from 'src/app/shared/integrations/psp/psp.service';

@Component({
  standalone: false,
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {
  user?: User;
  initials = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private pspService: PspService) {
    this.user = this.userService.getUser();
    this.initials = this.buildInitials(this.user?.name);
  }

  get isAuthenticated(): boolean {
    return this.user?.isAuthenticated ?? false;
  }

  private buildInitials(name?: string): string {
    if (!name) {
      return '';
    }
    return name
      .trim()
      .split(/\s+/)
      .map(part => part.charAt(0))
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }

  onLogOut() {
    this.authService.removeToken();
    localStorage.clear();
    location.reload();
  }

  onRentManagement() {
    if (!this.isAuthenticated) {
      this.authService.redirectToLogin();
      return;
    }

    this.pspService.openPayments();
  }

  onSecurityDeposit() {
    if (!this.isAuthenticated) {
      this.authService.redirectToLogin();
      return;
    }

    this.router.navigate(['/security-deposit/invites']);
  }
}
